<template>
  <div class="wrap" @drop.prevent @dragover.prevent @dragleave.prevent>
    <Nav></Nav>
    <router-view></router-view>
  </div>
</template>

<script>
import Nav from './components/nav.vue';

export default {
  components: {
    Nav
  }
};
</script>

<style lang="less">
@primary-color: #409EFF;
html, body {
  width: 100%;
  height: 100%;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body::before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: url(https://img.xjh.me/random_img.php?type=bg&ctype=nature&return=302);
  opacity: 0.15;
  pointer-events: none;
}
a{
  text-decoration: none;
}
table a {
  color: @primary-color;
  cursor: pointer;
}
.wrap {
  position: relative;
}
.color-primary {
  color: @primary-color;
}
.color-success {
  color: #67C23A;
}
.color-warning {
  color: #E6A23C;
}
.color-danger {
  color: #F56C6C;
}
.color-info {
  color: #909399;
}

/* 滚动条 */
::-webkit-scrollbar
{
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb
{
  width: 8px;

  -webkit-border-radius: 4px;
     -moz-border-radius: 4px;
          border-radius: 4px;
  background: #cbcbcb;
  &:hover
  {
    background: @primary-color + 20;
  }
}

::-webkit-scrollbar-track-piece
{
  border: none;
  background-color: #f5f5f5;
}
</style>
